import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

import { useSelector } from 'react-redux';
import { userSelector } from '../../features/user/userSlice';

import api from '../../services/api';
import apiErrorFormatter from '../../services/apiErrorFormatter';

import moment from 'moment';
import * as XLSX from 'xlsx';

import { TableVirtuoso } from 'react-virtuoso';

import { useTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';

import SvgIcon from '@mui/material/SvgIcon';
import RefreshIcon from '@mui/icons-material/Refresh';
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';

const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{
        minWidth: '1420px',
        borderCollapse: 'separate',
        tableLayout: 'fixed',
        '.MuiTableCell-head': {
          backgroundColor: 'primary.light',
          color: '#000000',
          fontWeight: 'bold',
        },
        '.MuiTableCell-root': {
          p: '4px',
          fontSize: '10px',
        },
      }}
      size="small"
    />
  ),
  TableHead,
  TableRow: ({ item: _item, ...props }) => {
    const { t } = useTranslation('maintenance');
    return (
      <>
        <TableRow
          {...props}
          // sx={
          //   {
          //     // '&:nth-of-type(odd)': {
          //     //   backgroundColor: 'action.hover',
          //     // },
          //     // '&:last-child td, &:last-child th': { border: 0 },
          //   }
          // }
          sx={{
            ...(props['data-index'] % 2 === 0 && {
              '& > *': { backgroundColor: 'action.hover' },
            }),
            ...(_item?.maintenanceTasksHistory?.length > 0 && {
              '& > :first-of-type': { borderBottom: 'unset' },
            }),
          }}
        />
        {_item?.maintenanceTasksHistory?.length > 0
          ? _item?.maintenanceTasksHistory?.map(
              (maintenanceTaskHistory, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '.MuiTableCell-root': { color: 'text.secondary' },
                    ...(props['data-index'] % 2 === 0 && {
                      '& > *': {
                        backgroundColor: 'action.hover',
                      },
                    }),
                    ...(index + 1 < _item?.maintenanceTasksHistory?.length && {
                      '& > :first-of-type': { borderBottom: 'unset' },
                    }),
                  }}
                >
                  <TableCell />
                  <TableCell>
                    {maintenanceTaskHistory?.historyTimestamp
                      ? moment(maintenanceTaskHistory?.historyTimestamp).format(
                          'L LTS'
                        )
                      : null}
                  </TableCell>
                  <TableCell>{maintenanceTaskHistory?.areaName}</TableCell>
                  <TableCell>{maintenanceTaskHistory?.lineName}</TableCell>
                  <TableCell>{maintenanceTaskHistory?.equipmentName}</TableCell>
                  <TableCell>
                    {t(maintenanceTaskHistory?.errorTypeName)}
                  </TableCell>
                  <TableCell>
                    {t(maintenanceTaskHistory?.priorityName)}
                  </TableCell>
                  <TableCell>
                    {t(maintenanceTaskHistory?.maintenanceTypeName)}
                  </TableCell>
                  <TableCell>
                    <Box
                    // sx={{
                    //   whiteSpace: 'nowrap',
                    // }}
                    >
                      {maintenanceTaskHistory?.createdByUsername}
                    </Box>
                    <Box>
                      {maintenanceTaskHistory?.createdAt
                        ? moment(maintenanceTaskHistory?.createdAt).format(
                            'L LTS'
                          )
                        : null}
                    </Box>
                    <Box
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        lineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                      }}
                    >
                      {maintenanceTaskHistory?.createdComment}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>{maintenanceTaskHistory?.startedByUsername}</Box>
                    <Box>
                      {maintenanceTaskHistory?.startedAt
                        ? moment(maintenanceTaskHistory?.startedAt).format(
                            'L LTS'
                          )
                        : null}
                    </Box>
                    <Box
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        lineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                      }}
                    >
                      {maintenanceTaskHistory?.startedComment}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>{maintenanceTaskHistory?.finishedByUsername}</Box>
                    <Box>
                      {maintenanceTaskHistory?.finishedAt
                        ? moment(maintenanceTaskHistory?.finishedAt).format(
                            'L LTS'
                          )
                        : null}
                    </Box>
                    <Box
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        lineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                      }}
                    >
                      {maintenanceTaskHistory?.finishedComment}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box>{maintenanceTaskHistory?.acknowledgedByUsername}</Box>
                    <Box>
                      {maintenanceTaskHistory?.acknowledgedAt
                        ? moment(maintenanceTaskHistory?.acknowledgedAt).format(
                            'L LTS'
                          )
                        : null}
                    </Box>
                    <Box
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        lineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                      }}
                    >
                      {maintenanceTaskHistory?.acknowledgedComment}
                    </Box>
                  </TableCell>
                  <TableCell>{t(maintenanceTaskHistory?.status)}</TableCell>
                </TableRow>
              )
            )
          : null}
      </>
    );
  },
  TableBody: React.forwardRef((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};

function ReportMaintenanceTasks() {
  const { t } = useTranslation('maintenance');

  const { user } = useSelector(userSelector);
  const plantId = user?.plant?.id > 0 ? user?.plant?.id : 0;

  const theme = useTheme();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [showContent, setShowContent] = useState(false);

  const [areas, setAreas] = useState([]);
  const [lines, setLines] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [errorTypes, setErrorTypes] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [maintenanceTypes, setMaintenanceTypes] = useState([]);

  const [selectedAreaId, setSelectedAreaId] = useState('');
  const [selectedLineId, setSelectedLineId] = useState('');
  const [selectedEquipmentId, setSelectedEquipmentId] = useState('');
  const [selectedErrorTypeId, setSelectedErrorTypeId] = useState('');
  const [selectedPriorityId, setSelectedPriorityId] = useState('');
  const [selectedMaintenanceTypeId, setSelectedMaintenanceTypeId] =
    useState('');
  const [selectedOperation, setSelectedOperation] = useState('');
  const [dateFrom, setDateFrom] = useState(moment());
  const [dateTo, setDateTo] = useState(moment());
  const [dateFromError, setDateFromError] = useState(false);
  const [dateToError, setDateToError] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [withHistory, setWithHistory] = useState(false);

  const [reportData, setReportData] = useState({});

  const availableLines =
    selectedAreaId > 0
      ? lines.filter((line) => line.areaId === selectedAreaId)
      : lines;
  const availableEquipments =
    selectedLineId > 0
      ? equipments.filter((x) => x?.lineId === selectedLineId)
      : equipments.filter((equipment) =>
          availableLines.some((line) => line.id === equipment.lineId)
        );
  const availableErrorTypes =
    selectedEquipmentId > 0
      ? equipments?.find((equipment) => equipment?.id === selectedEquipmentId)
          ?.errorTypes
      : errorTypes;

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setReportData({});
  }, [
    selectedAreaId,
    selectedLineId,
    selectedEquipmentId,
    selectedErrorTypeId,
    selectedPriorityId,
    selectedMaintenanceTypeId,
    selectedOperation,
    dateFrom,
    dateTo,
    selectedStatus,
    withHistory,
  ]);

  const getData = async () => {
    setLoading(true);
    setErrors([]);
    setShowContent(false);
    setAreas([]);
    setLines([]);
    setEquipments([]);
    setErrorTypes([]);
    setPriorities([]);
    setMaintenanceTypes([]);
    let errors = [];
    await api.get('/maintenance/areas', { params: { plantId: plantId } }).then(
      (res) => {
        setAreas(res?.data);
      },
      (err) => {
        errors = apiErrorFormatter(err);
      }
    );
    await api.get('/maintenance/lines', { params: { plantId: plantId } }).then(
      (res) => {
        setLines(res?.data);
      },
      (err) => {
        errors = errors.concat(
          apiErrorFormatter(err).filter((item) => errors.indexOf(item) < 0)
        );
      }
    );
    await api
      .get('/maintenance/equipments', { params: { plantId: plantId } })
      .then(
        (res) => {
          setEquipments(res?.data);
        },
        (err) => {
          errors = errors.concat(
            apiErrorFormatter(err).filter((item) => errors.indexOf(item) < 0)
          );
        }
      );
    await api.get('/maintenance/error-types').then(
      (res) => {
        setErrorTypes(res?.data);
      },
      (err) => {
        errors = errors.concat(
          apiErrorFormatter(err).filter((item) => errors.indexOf(item) < 0)
        );
      }
    );
    await api.get('/maintenance/priorities').then(
      (res) => {
        setPriorities(res?.data);
      },
      (err) => {
        errors = errors.concat(
          apiErrorFormatter(err).filter((item) => errors.indexOf(item) < 0)
        );
      }
    );
    await api.get('/maintenance/maintenance-types').then(
      (res) => {
        setMaintenanceTypes(res?.data);
      },
      (err) => {
        errors = errors.concat(
          apiErrorFormatter(err).filter((item) => errors.indexOf(item) < 0)
        );
      }
    );
    if (errors.length === 0) setShowContent(true);
    else setErrors(apiErrorFormatter(errors));
    setLoading(false);
  };

  const getReport = async () => {
    setLoading(true);
    setErrors([]);
    setReportData({});
    await api
      .get('/maintenance/report-maintenance-tasks', {
        params: {
          plantId: plantId,
          areaId: selectedAreaId,
          lineId: selectedLineId,
          equipmentId: selectedEquipmentId,
          errorTypeId: selectedErrorTypeId,
          priorityId: selectedPriorityId,
          maintenanceTypeId: selectedMaintenanceTypeId,
          operation: selectedOperation,
          dateFrom: moment(dateFrom).format('MM/DD/YYYY 00:00:00'),
          dateTo: moment(dateTo).format('MM/DD/YYYY 23:59:59'),
          status: selectedStatus,
          withHistory: withHistory,
        },
      })
      .then(
        (res) => {
          setReportData(res?.data);
        },
        (err) => {
          setErrors(apiErrorFormatter(err));
        }
      );
    setLoading(false);
  };

  const createMaintenanceTaskObjectForExport = (x) => {
    return {
      maintenanceTaskId: x?.maintenanceTaskId,
      isHistory: x?.isHistory,
      historyTimestamp: x?.historyTimestamp
        ? moment(x?.historyTimestamp).format('L LTS')
        : null,
      plantId: x?.plantId,
      plantName: x?.plantName,
      areaId: x?.areaId,
      areaName: x?.areaName,
      lineId: x?.lineId,
      lineName: x?.lineName,
      equipmentId: x?.equipmentId,
      equipmentName: x?.equipmentName,
      errorTypeId: x?.errorTypeId,
      errorTypeName: t(x?.errorTypeName)
        ? t(x?.errorTypeName)
        : x?.errorTypeName,
      priorityId: x?.priorityId,
      priorityName: t(x?.priorityName) ? t(x?.priorityName) : x?.priorityName,
      maintenanceTypeId: x?.maintenanceTypeId,
      maintenanceTypeName: t(x?.maintenanceTypeName)
        ? t(x?.maintenanceTypeName)
        : x?.maintenanceTypeName,
      createdByUserId: x?.createdByUserId > 0 ? x?.createdByUserId : null,
      createdByUsername: x?.createdByUsername,
      createdAt: x?.createdAt ? moment(x?.createdAt).format('L LTS') : null,
      createdComment: x?.createdComment,
      startedByUserId: x?.startedByUserId > 0 ? x?.startedByUserId : null,
      startedByUsername: x?.startedByUsername,
      startedAt: x?.startedAt ? moment(x?.startedAt).format('L LTS') : null,
      startedComment: x?.startedComment,
      finishedByUserId: x?.finishedByUserId > 0 ? x?.finishedByUserId : null,
      finishedByUsername: x?.finishedByUsername,
      finishedAt: x?.finishedAt ? moment(x?.finishedAt).format('L LTS') : null,
      finishedComment: x?.finishedComment,
      acknowledgedByUserId:
        x?.acknowledgedByUserId > 0 ? x?.acknowledgedByUserId : null,
      acknowledgedByUsername: x?.acknowledgedByUsername,
      acknowledgedAt: x?.acknowledgedAt
        ? moment(x?.acknowledgedAt).format('L LTS')
        : null,
      acknowledgedComment: x?.acknowledgedComment,
      status: t(x?.status) ? t(x?.status) : x?.status,
    };
  };

  const handleExportToFile = () => {
    if (reportData?.maintenanceTasks.length > 0) {
      const workbook = XLSX.utils.book_new();

      let maintenanceTasksForExport = reportData?.maintenanceTasks?.reduce(
        (acc, obj) => {
          const newObj = createMaintenanceTaskObjectForExport(obj);
          acc.push(newObj);
          if (obj?.maintenanceTasksHistory?.length > 0) {
            const history = obj?.maintenanceTasksHistory?.map(
              createMaintenanceTaskObjectForExport
            );
            acc.push(...history);
          }
          return acc;
        },
        []
      );
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(maintenanceTasksForExport),
        'Maintenance tasks'
      );
      // if (this.state.content?.sensorAlertAcknowledgements?.length > 0) {
      //   const wsSensorAlertAcknowledgements = XLSX.utils.json_to_sheet(
      //     this.state.content?.sensorAlertAcknowledgements
      //   );
      //   XLSX.utils.book_append_sheet(
      //     workbook,
      //     wsSensorAlertAcknowledgements,
      //     'Sensor alert acknowledgements'
      //   );
      // }
      XLSX.writeFile(
        workbook,
        'ReportMaintenanceTasks_' +
          moment().format('YYYYMMDD_HHmmss') +
          '.xlsx',
        { compression: true }
      );
    }
  };

  const handleChangeSelectedArea = (event) => {
    const value = event.target.value;
    const newAvailableLines =
      value > 0 ? lines.filter((line) => line?.areaId === value) : lines;
    const newAvailableEquipments = equipments.filter((equipment) =>
      newAvailableLines.some((line) => line.id === equipment.lineId)
    );
    if (
      selectedEquipmentId > 0 &&
      !newAvailableEquipments.some(
        (equipment) => equipment?.id === selectedEquipmentId
      )
    ) {
      setSelectedEquipmentId('');
    }
    if (
      selectedLineId > 0 &&
      !newAvailableLines.some((line) => line?.id === selectedLineId)
    ) {
      setSelectedLineId('');
    }
    setSelectedAreaId(value);
  };

  const handleChangeSelectedLine = (event) => {
    const value = event.target.value;
    const newAvailableEquipments =
      value > 0
        ? equipments.filter((equipment) => equipment?.lineId === value)
        : equipments;
    if (
      selectedEquipmentId > 0 &&
      !newAvailableEquipments.some(
        (equipment) => equipment?.id === selectedEquipmentId
      )
    ) {
      setSelectedEquipmentId('');
    }
    setSelectedLineId(value);
  };

  const handleChangeSelectedEquipment = (event) => {
    const value = event.target.value;
    if (value > 0 && selectedErrorTypeId > 0) {
      if (
        !equipments
          ?.find((equipment) => equipment?.id === value)
          ?.errorTypes?.find(
            (errorType) => errorType?.id === selectedErrorTypeId
          )
      ) {
        setSelectedErrorTypeId('');
      }
    }
    setSelectedEquipmentId(value);
  };

  const resetFilters = () => {
    setSelectedAreaId('');
    setSelectedLineId('');
    setSelectedEquipmentId('');
    setSelectedErrorTypeId('');
    setSelectedPriorityId('');
    setSelectedMaintenanceTypeId('');
    setSelectedOperation('');
    setDateFrom(moment());
    setDateTo(moment());
    setSelectedStatus('');
    setWithHistory(false);
  };

  const checkIsFiltered = () => {
    if (
      selectedAreaId > 0 ||
      selectedLineId > 0 ||
      selectedEquipmentId > 0 ||
      selectedErrorTypeId > 0 ||
      selectedPriorityId > 0 ||
      selectedMaintenanceTypeId > 0 ||
      selectedOperation !== '' ||
      !dateFrom ||
      !dateTo ||
      dateFromError ||
      dateToError ||
      !moment().isSame(dateFrom, 'day') ||
      !moment().isSame(dateTo, 'day') ||
      selectedStatus !== '' ||
      withHistory
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkAreFiltersValid = () => {
    if (
      dateFrom &&
      dateTo &&
      !dateFromError &&
      !dateToError &&
      dateFrom <= dateTo
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isFiltered = checkIsFiltered();
  const areFiltersValid = checkAreFiltersValid();

  return (
    <Container sx={{ mt: 1, mb: 10 }} maxWidth={false}>
      <Box mb={1}>
        <Divider>{t('report_maintenance_tasks')}</Divider>
      </Box>
      {/* <Paper sx={{ p: 1, textAlign: 'center' }} variant="outlined">
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="contained"
            sx={{ px: 4, py: 2 }}
            disabled={loading}
            startIcon={
              !loading ? (
                <ArrowBackIcon />
              ) : (
                <CircularProgress color="inherit" size={20} />
              )
            }
            component={RouterLink}
            to=".."
            relative="path"
          >
            {t('common:back')}
          </Button>
        </Box>
      </Paper> */}
      {!showContent && loading ? (
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={'60px'} />
        </Box>
      ) : null}
      {!showContent && errors.length > 0 ? (
        <Box>
          {errors
            .slice()
            .reverse()
            .map((error) => (
              <Box key={error} mt={1}>
                <Alert variant="outlined" severity="error">
                  {t(error)}
                </Alert>
              </Box>
            ))}
        </Box>
      ) : null}
      {showContent ? (
        <>
          <Paper
            sx={{ pt: 1, pb: 1, pl: 1, pr: 1, textAlign: 'center' }}
            variant="outlined"
          >
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                flexWrap: 'wrap',
              }}
            >
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ py: 1 }}
                  // fullWidth
                  disabled={loading || !areFiltersValid}
                  startIcon={
                    !loading ? (
                      <RefreshIcon />
                    ) : (
                      <CircularProgress color="inherit" size={20} />
                    )
                  }
                  onClick={getReport}
                >
                  {t('common:refresh')}
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    py: 1,
                    color: 'primary.contrastText',
                    backgroundColor: 'error.main',
                    ':hover': {
                      color: 'primary.contrastText',
                      backgroundColor: 'error.dark',
                    },
                  }}
                  // fullWidth
                  disabled={loading || !isFiltered}
                  startIcon={
                    !loading ? (
                      <FilterAltOffOutlinedIcon />
                    ) : (
                      <CircularProgress color="inherit" size={20} />
                    )
                  }
                  onClick={resetFilters}
                >
                  {t('common:reset_filters')}
                </Button>
              </Box>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '174px' }}
                id="areaId"
                label={t('area')}
                value={selectedAreaId}
                onChange={handleChangeSelectedArea}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                {areas?.map((area) => (
                  <MenuItem key={area?.id} value={area?.id}>
                    {area?.areaName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '174px' }}
                id="lineId"
                label={t('line')}
                value={selectedLineId}
                onChange={handleChangeSelectedLine}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                {availableLines?.map((line) => (
                  <MenuItem key={line?.id} value={line?.id}>
                    {line?.lineName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '200px' }}
                id="equipmentId"
                label={t('equipment')}
                value={selectedEquipmentId}
                onChange={handleChangeSelectedEquipment}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                {availableEquipments?.map((equipment) => (
                  <MenuItem key={equipment?.id} value={equipment?.id}>
                    {equipment?.equipmentName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '336px' }}
                id="errorTypeId"
                label={t('error_type')}
                value={selectedErrorTypeId}
                onChange={(event) => {
                  setSelectedErrorTypeId(event.target.value);
                }}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                {availableErrorTypes?.map((errorType) => (
                  <MenuItem key={errorType?.id} value={errorType?.id}>
                    {t(errorType?.errorTypeName)}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '336px' }}
                id="priorityId"
                label={t('priority')}
                value={selectedPriorityId}
                onChange={(event) => {
                  setSelectedPriorityId(event.target.value);
                }}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                {priorities?.map((priority) => (
                  <MenuItem key={priority?.id} value={priority?.id}>
                    {t(priority?.priorityName)}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '180px' }}
                id="maintenanceTypeId"
                label={t('maintenance_type')}
                value={selectedMaintenanceTypeId}
                onChange={(event) => {
                  setSelectedMaintenanceTypeId(event.target.value);
                }}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                {maintenanceTypes?.map((maintenanceType) => (
                  <MenuItem
                    key={maintenanceType?.id}
                    value={maintenanceType?.id}
                  >
                    {t(maintenanceType?.maintenanceTypeName)}
                  </MenuItem>
                ))}
              </TextField>
              <Box
                sx={{
                  flexGrow: 1,
                  flexBasis: '520px',
                  display: 'flex',
                  gap: 2,
                  flexWrap: 'wrap',
                }}
              >
                <TextField
                  fullWidth
                  select
                  size="small"
                  sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '200px' }}
                  id="operation"
                  label={t('operation')}
                  value={selectedOperation}
                  onChange={(event) => {
                    setSelectedOperation(event.target.value);
                  }}
                  disabled={loading}
                >
                  <MenuItem value="">
                    <em>{t('common:none')}</em>
                  </MenuItem>
                  <MenuItem value="created_at">
                    <em>{t('created_at')}</em>
                  </MenuItem>
                  <MenuItem value="started_at">
                    <em>{t('started_at')}</em>
                  </MenuItem>
                  <MenuItem value="finished_at">
                    <em>{t('finished_at')}</em>
                  </MenuItem>
                  <MenuItem value="acknowledged_at">
                    <em>{t('acknowledged_at')}</em>
                  </MenuItem>
                </TextField>
                <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  adapterLocale={i18n.language}
                >
                  <DatePicker
                    sx={{ flexGrow: 1, flexBasis: '150px' }}
                    slotProps={{ field: { size: 'small' } }}
                    label={t('common:date_from')}
                    value={dateFrom}
                    onChange={(newValue) => setDateFrom(newValue)}
                    onError={(error) => setDateFromError(error ? true : false)}
                    maxDate={dateTo}
                    disabled={selectedOperation === ''}
                  />
                  <DatePicker
                    sx={{ flexGrow: 1, flexBasis: '150px' }}
                    slotProps={{ field: { size: 'small' } }}
                    label={t('common:date_to')}
                    value={dateTo}
                    onChange={(newValue) => setDateTo(newValue)}
                    onError={(error) => setDateToError(error ? true : false)}
                    minDate={dateFrom}
                    disabled={selectedOperation === ''}
                  />
                </LocalizationProvider>
              </Box>
              <TextField
                fullWidth
                select
                size="small"
                sx={{ textAlign: 'left', flexGrow: 1, flexBasis: '160px' }}
                id="status"
                label={t('common:status')}
                value={selectedStatus}
                onChange={(event) => {
                  setSelectedStatus(event.target.value);
                }}
                disabled={loading}
              >
                <MenuItem value="">
                  <em>{t('common:none')}</em>
                </MenuItem>
                <MenuItem value="waiting_for_start">
                  <em>{t('waiting_for_start')}</em>
                </MenuItem>
                <MenuItem value="waiting_for_finish">
                  <em>{t('waiting_for_finish')}</em>
                </MenuItem>
                <MenuItem value="waiting_for_acknowledgement">
                  <em>{t('waiting_for_acknowledgement')}</em>
                </MenuItem>
                <MenuItem value="accepted">
                  <em>{t('accepted')}</em>
                </MenuItem>
                <MenuItem value="rejected">
                  <em>{t('rejected')}</em>
                </MenuItem>
              </TextField>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={withHistory}
                    onChange={(event) => {
                      setWithHistory(event.target.checked);
                    }}
                  />
                }
                label={t('common:with_history')}
              />
            </Box>
          </Paper>
          <Box sx={{ mt: 2 }}>
            {loading ? (
              <Box sx={{ textAlign: 'center' }}>
                <CircularProgress size={'60px'} />
              </Box>
            ) : null}
            {!loading && errors.length === 0 && reportData?.maintenanceTasks ? (
              <Box sx={{ height: '70vh', minHeight: '500px' }}>
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ py: 1 }}
                  // fullWidth
                  disabled={
                    loading ||
                    !reportData?.maintenanceTasks ||
                    reportData?.maintenanceTasks?.length <= 0
                  }
                  startIcon={
                    !loading ? (
                      <SvgIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 14 14"
                          fill={theme.palette.primary.contrastText}
                        >
                          <path d="m 12.7765,2.551 -4.02,0 0,0.744 1.185,0 0,1.177 -1.185,0 0,0.375 1.185,0 0,1.1785 -1.185,0 0,0.3855 1.185,0 0,1.1145 -1.185,0 0,0.4465 1.185,0 0,1.117 -1.185,0 0,0.4465 1.185,0 0,1.1235 -1.185,0 0,0.8195 4.02,0 c 0.0635,-0.019 0.1165,-0.094 0.159,-0.224 C 12.978,11.1235 13,11.017 13,10.9365 L 13,2.687 C 13,2.623 12.978,2.5845 12.9355,2.571 12.893,2.558 12.84,2.551 12.7765,2.551 Z m -0.5215,8.107 -1.9285,0 0,-1.1225 1.9285,0 0,1.1235 0,-0.001 z m 0,-1.569 -1.9285,0 0,-1.1175 1.9285,0 0,1.1175 z m 0,-1.564 -1.9285,0 0,-1.1095 1.9285,0 0,1.1105 0,-10e-4 z m 0,-1.5 -1.9285,0 0,-1.177 1.9285,0 0,1.1775 0,-5e-4 z m 0,-1.5595 -1.9285,0 0,-1.17 1.9285,0 0,1.1775 0,-0.0075 z M 1,2.3655 1,11.666 8.08,12.8905 8.08,1.1095 1,2.3695 1,2.3655 Z M 5.1965,9.401 C 5.1695,9.328 5.0425,9.018 4.8175,8.4695 4.593,7.9215 4.4575,7.6025 4.418,7.5115 l -0.0125,0 L 3.646,9.319 2.631,9.2505 l 1.204,-2.25 -1.1025,-2.25 1.035,-0.0545 0.684,1.7605 0.0135,0 L 5.2375,4.616 6.307,4.5485 5.0335,6.9835 6.346,9.4675 5.1965,9.4 l 0,10e-4 z" />
                        </svg>
                      </SvgIcon>
                    ) : (
                      <CircularProgress color="inherit" size={20} />
                    )
                  }
                  onClick={handleExportToFile}
                >
                  {t('common:export_to_excel')}
                </Button>
                <Paper
                  sx={{
                    mt: 1,
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <TableVirtuoso
                    // style={{ height: '100%' }}
                    data={reportData?.maintenanceTasks}
                    components={VirtuosoTableComponents}
                    fixedHeaderContent={() => (
                      <TableRow>
                        <TableCell variant="head" style={{ width: '40px' }}>
                          #
                        </TableCell>
                        {withHistory ? (
                          <TableCell
                            variant="head"
                            style={{ width: '160px' }}
                          />
                        ) : null}
                        <TableCell variant="head" style={{ width: '96px' }}>
                          {t('area')}
                        </TableCell>
                        <TableCell variant="head" style={{ width: '96px' }}>
                          {t('line')}
                        </TableCell>
                        <TableCell variant="head" style={{ width: '110px' }}>
                          {t('equipment')}
                        </TableCell>
                        <TableCell variant="head" style={{ width: '130px' }}>
                          {t('error_type')}
                        </TableCell>
                        <TableCell variant="head" style={{ width: '142px' }}>
                          {t('priority')}
                        </TableCell>
                        <TableCell variant="head" style={{ width: '120px' }}>
                          {t('maintenance_type')}
                        </TableCell>
                        <TableCell variant="head">{t('created')}</TableCell>
                        <TableCell variant="head">{t('started')}</TableCell>
                        <TableCell variant="head">{t('finished')}</TableCell>
                        <TableCell variant="head">
                          {t('acknowledged')}
                        </TableCell>
                        <TableCell variant="head" style={{ width: '96px' }}>
                          {t('common:status')}
                        </TableCell>
                      </TableRow>
                    )}
                    itemContent={(index, maintenanceTask) => (
                      <>
                        <TableCell>
                          {maintenanceTask?.maintenanceTaskId}
                        </TableCell>
                        {withHistory ? <TableCell /> : null}
                        <TableCell>{maintenanceTask?.areaName}</TableCell>
                        <TableCell>{maintenanceTask?.lineName}</TableCell>
                        <TableCell>{maintenanceTask?.equipmentName}</TableCell>
                        <TableCell>
                          {t(maintenanceTask?.errorTypeName)}
                        </TableCell>
                        <TableCell>
                          {t(maintenanceTask?.priorityName)}
                        </TableCell>
                        <TableCell>
                          {t(maintenanceTask?.maintenanceTypeName)}
                        </TableCell>
                        <TableCell>
                          <Box
                          // sx={{
                          //   whiteSpace: 'nowrap',
                          // }}
                          >
                            {maintenanceTask?.createdByUsername}
                          </Box>
                          <Box>
                            {maintenanceTask?.createdAt
                              ? moment(maintenanceTask?.createdAt).format(
                                  'L LTS'
                                )
                              : null}
                          </Box>
                          <Box
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              lineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              wordBreak: 'break-word',
                            }}
                          >
                            {maintenanceTask?.createdComment}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box>{maintenanceTask?.startedByUsername}</Box>
                          <Box>
                            {maintenanceTask?.startedAt
                              ? moment(maintenanceTask?.startedAt).format(
                                  'L LTS'
                                )
                              : null}
                          </Box>
                          <Box
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              lineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              wordBreak: 'break-word',
                            }}
                          >
                            {maintenanceTask?.startedComment}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box>{maintenanceTask?.finishedByUsername}</Box>
                          <Box>
                            {maintenanceTask?.finishedAt
                              ? moment(maintenanceTask?.finishedAt).format(
                                  'L LTS'
                                )
                              : null}
                          </Box>
                          <Box
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              lineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              wordBreak: 'break-word',
                            }}
                          >
                            {maintenanceTask?.finishedComment}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box>{maintenanceTask?.acknowledgedByUsername}</Box>
                          <Box>
                            {maintenanceTask?.acknowledgedAt
                              ? moment(maintenanceTask?.acknowledgedAt).format(
                                  'L LTS'
                                )
                              : null}
                          </Box>
                          <Box
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: '1',
                              lineClamp: '1',
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              wordBreak: 'break-word',
                            }}
                          >
                            {maintenanceTask?.acknowledgedComment}
                          </Box>
                        </TableCell>
                        <TableCell>{t(maintenanceTask?.status)}</TableCell>
                      </>
                    )}
                  />
                </Paper>
              </Box>
            ) : null}
            {errors.length > 0 ? (
              <Box>
                {errors
                  .slice()
                  .reverse()
                  .map((error) => (
                    <Box key={error} mt={1}>
                      <Alert variant="outlined" severity="error">
                        {t(error)}
                      </Alert>
                    </Box>
                  ))}
              </Box>
            ) : null}
          </Box>
        </>
      ) : null}
      {/* </Container> */}
    </Container>
  );
}

export default ReportMaintenanceTasks;
